import { render, staticRenderFns } from "./learning-performance.vue?vue&type=template&id=522dc90e&scoped=true"
import script from "./learning-performance.vue?vue&type=script&lang=js"
export * from "./learning-performance.vue?vue&type=script&lang=js"
import style0 from "./learning-performance.vue?vue&type=style&index=0&id=522dc90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522dc90e",
  null
  
)

export default component.exports